/**
 * Onboarding V2 route paths — one definition, imported by every navigator.
 *
 * The URL says `/onboarding`, not `/onboarding-v2` or `/preview/…`: this is the
 * first screen a new account ever sees, and "preview" / "v2" in the address bar
 * reads as an unfinished product. "V2" stays as the INTERNAL name of the
 * implementation (directory, model, components) — it describes which build this
 * is, which is a fact about the code, not something a customer needs in a URL.
 *
 * The `<Route path=…>` attributes in App.tsx stay written as literals on
 * purpose: the invariants suite locates and asserts the route structure by
 * searching App.tsx for those exact strings. Keep the literals and the values
 * here in sync — they are the same two paths.
 */

export const ONBOARDING_V2_PREFLIGHT_PATH = '/onboarding';
export const ONBOARDING_V2_DASHBOARD_PATH = '/onboarding/dashboard';

/**
 * The paths these routes used to live at, kept as redirects.
 *
 * The old URLs were live on this branch and the gate actively sent users to
 * them, so an open tab, a bookmark, or a browser-restored session would
 * otherwise land on NotFound — in the middle of first-run setup, which is the
 * worst possible place for a dead end.
 *
 * The query string is deliberately dropped: without `?resume=`,
 * `resolveResumeStep` falls back to the draft's own `currentStep`, which is
 * where the user actually left off.
 */
export const ONBOARDING_V2_LEGACY_PREFLIGHT_PATH = '/preview/onboarding-v2';
export const ONBOARDING_V2_LEGACY_DASHBOARD_PATH = '/preview/onboarding-v2/dashboard';
